import React, { Component } from 'react';
import CurrencyFormat from 'react-currency-format';
import { useCurrency } from '../../../../jsx/hooks/useCurrency';


// function MonComposant() {
//   const currency = useCurrency();

//   ...
// }

function Currency(props) {
    const currency = useCurrency();
    //console.log('===============CURRENCY=====================');
    //console.log(currency);
    //console.log('====================================');
    let value = 0
    if ( props.value !== undefined){
        // Preserve decimals for all currencies
        value = parseFloat(props.value) || 0
    }
    let symbol = ""
    if (currency == "Euro") {
        // Round to 2 decimal places for Euro
        value = Math.round(value * 100) / 100
        symbol = "€"
        // let value = props.round ? Math.round(props.value * 100) / 100 : props.value
    } else {
        // Round to 2 decimal places for FCFA as well
        value = Math.round(value * 100) / 100
        symbol = "FCFA"

    }
    return (
        <CurrencyFormat 
            value={value} 
            displayType={'text'} 
            thousandSeparator={" "} 
            decimalScale={2}
            fixedDecimalScale={false}
            suffix={` ${symbol}`}
            // suffix={props.suffix || " FCFA"}
            prefix={props.prefix || ""}
            style={{ whiteSpace: "nowrap" }}
        />
    );
    
}

export default Currency; 
